export default function registrationBillingForm() {
	document.addEventListener('DOMContentLoaded', function () {
		// Select radio buttons and input field container
		const vatIncl = document.getElementById('vatIncl');
		const vatExcl = document.getElementById('vatExcl');

		const chamberOfCommerceId = document.getElementById('chamberOfCommerceId');
		const taxNumber = document.getElementById('companyTaxNumber');
		const taxNumberVatInput = document.getElementById('taxNumberVatInput');
		const countryCode = window?.dataLayer?.[0]?.navigation?.countryISO;

		if (taxNumber && chamberOfCommerceId) {
			taxNumber.value = `${countryCode}`;
			const handleVatRadioGroup = ({ target }) => {
				const chamberOfCommerceIdInput = document.querySelector(
					'.chamber-of-commerce-vat-input',
				);
				const isMandatory = target.value === 'yes';
				chamberOfCommerceIdInput.classList.toggle(
					'form-inline-row--is-mandatory',
					isMandatory,
				);
				taxNumberVatInput.toggleAttribute('hidden', !isMandatory);
				taxNumber.name = isMandatory ? 'companyTaxNumber' : '';
			};

			vatIncl?.addEventListener('change', handleVatRadioGroup);
			vatExcl?.addEventListener('change', handleVatRadioGroup);

			chamberOfCommerceId.addEventListener('input', function () {
				if (countryCode) {
					taxNumber.value = `${countryCode}${chamberOfCommerceId.value}`;
				}
			});
		}
	});
}
